import { createUseStyles } from "react-jss";
import { ITheme } from "../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    height: window.innerHeight,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  content: {
    marginTop: 70,
    padding: `${theme.spacing.space8}px ${theme.spacing.space20}px`,
  },
  endTime: {
    display: "flex",
    alignItems: "center",
    paddingBottom: theme.spacing.space8,
    justifyContent: "space-between",
  },
  iconTimer: {
    marginRight: 4,
    padding: 4,
    borderRadius: "50%",
    background: theme.colors.border1,
  },
}));
